import { Card, Stack } from "@mui/material";
import React from "react";
import SvgDiagram from "../../SvgDiagram";

export default function TanitaMC780BIAInfoCard({data}) {
    const image = {
        // 704 × 558 pixels
        w: 704, h:518,
        src: "/assets/tanita/mc780/bia_info_panel.png"
    }

    return <Card sx={{maxWidth:900}}>
        <Stack direction="column">
            <SvgDiagram image={image} markers={[]}/>
        </Stack>
    </Card>
}